import { useEffect } from 'react';
import { MetaContainer, SearchEngine } from '../../state/meta';
import { Routing } from '../Routes';
import { SearchPageLoop54 } from './SearchPageLoop54';
import { useConfig } from '../../config';
import { randomBool } from '../utils';
import { Loader } from '../Loader/Loader';
import { Main } from '../Main/Main';
import { cookieService } from '../cookieService';

export const SearchPageWrapper = (): JSX.Element => {
	const { searchEngine, searchProfileId } = MetaContainer.useContainer();
	const { store, currencyCode } = useConfig();
	const meta = MetaContainer.useContainer();

	useEffect(() => {
		if (typeof window.fbq !== 'undefined') {
			if (store === 'kgse') {
				window.fbq('track', 'Search', {
					currency: currencyCode,
				});
			}
		}

		const cookieSearchEngine = cookieService.read('searchEngine') as SearchEngine;
		let engine: SearchEngine = randomBool() ? 'loop' : 'solr';
		if (!cookieSearchEngine) {
			cookieService.write('searchEngine', engine, 365);
			meta.setSearchEngine(engine);
		} else {
			// re-randomize searchEngine cookie for users with the 'not-set' value
			if (cookieSearchEngine === 'not-set') {
				engine = randomBool() ? 'loop' : 'solr';
				cookieService.write('searchEngine', engine, 365);
			} else {
				engine = cookieSearchEngine;
			}
			meta.setSearchEngine(engine);
		}
	}, []);

	if (!searchEngine || !searchProfileId) {
		return (
			<Main>
				<Loader />
			</Main>
		);
	}

	return <SearchPageLoop54 />;
};

export const searchRouting: Routing = {
	path(urls) {
		return urls.search;
	},
	component: SearchPageWrapper,
	requiresAuth: false,
};
